'use strict';

module.exports = function ($stateProvider) {

    $stateProvider
        .state('dashboard.departments.department', {
            url: '/:departmentId',
            templateUrl: 'dashboard-department/dashboard-department.html',
            controller: 'dashboardDepartmentCtrl as ctrl',
            resolve: {
                formsPreview: ['Department', '$stateParams', 'departments', '$state', 'Authentication', function (Department, $stateParams, departments, $state, Authentication) {
                    if (!$stateParams.departmentId && departments.length) {
                        let deptId = localStorage.getItem('lastDepartment');
                        let departmentExists = departments.find(dept => dept.id == deptId);
                        let targetDeptId = departmentExists ? deptId : departments[0].id;
                        return $state.go('dashboard.departments.department.forms', {
                            departmentId: targetDeptId
                        });
                    }
                    const deptOnlyViewer = Authentication.isOnlyViewerInDept($stateParams.departmentId);
                    if (deptOnlyViewer || Authentication.isAuthorized("viewer")) {
                        return departments.reduce(function (ret, item) {
                            if (item.id == $stateParams.departmentId)
                                return item.forms
                            else
                                return ret;
                        }, {});
                    } else
                        return departments.find(d=>d.id==$stateParams.departmentId).forms;
                }],
                tasksPreview: ['$stateParams', 'Department', 'Authentication','$state', function ($stateParams, Department, Authentication,$state) {
                    var startDate;
                    var endDate;
                    startDate = new Date();

                    startDate.setHours(0);
                    startDate.setMinutes(0);
                    startDate.setSeconds(0);
                    startDate.setMilliseconds(0);

                    endDate = new Date(startDate.getTime() + (1000 * 60 * 60 * 24));
                    if (Authentication.isAuthorized("viewer") || $stateParams.departmentId=="") {
                        return [];
                    } else
                        return Department.teams({
                            id: $stateParams.departmentId,
                            filter: {
                                include: {
                                    relation: 'members',
                                    scope: {
                                        include: {
                                            relation: 'task',
                                            scope: {
                                                where: {
                                                    or: [{
                                                        startDate: {
                                                            between: [startDate, endDate]
                                                        }
                                                    }, {
                                                        and: [{
                                                            repeat: true
                                                        }]
                                                    }]
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }).$promise
                            .then(function (tasks) {
                                //we flatten to only the members...
                                tasks = tasks.map(function (team) {
                                    return team.members;
                                });

                                //we consolidate all the teams
                                tasks = tasks.reduce(function (prev, team) {
                                    prev = prev.concat(team);
                                    return prev;
                                }, []);

                                return tasks.reduce(function (prev, member) {
                                    for (var i = 0; i < prev.length; i++) {
                                        if (prev[i].id === member.id) {
                                            return prev;
                                        }
                                    }

                                    prev.push(member);
                                    return prev;

                                }, []);
                            });

                }]
            },
            data: {
                authorizedRoles: ['admin', 'mobileUser', 'viewer']
            }
        });
};
